import { MuiButton } from "./MuiButton";
import { MuiTextField } from "./MuiTextField";

export const overrides = {
    MuiButton,
    MuiTextField,
};
